import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: {
      position: 'relative',
      boxSizing: 'border-box',
      display: 'block',
      outline: 'none'
    },
    overlay: {
      position: 'fixed',
      width: '100%',
      zIndex: 1000,
      top: 0,
      right: 0,
      bottom: 0,
      background: theme.colors.overlay,
      '&.ReactModal__Overlay': {
        opacity: 0,
        transition: 'opacity 300ms ease-in-out'
      },
      '&.ReactModal__Overlay--after-open': {
        opacity: 1,
        transition: 'opacity 300ms ease-in-out'
      },
      '&.ReactModal__Overlay--before-close': {
        opacity: 0
      }
    },
    container: _objectSpread(_objectSpread({
      maxHeight: 'calc(100vh - 20px)',
      padding: '32px',
      boxSizing: 'border-box',
      background: theme.colors.neutralBase
    }, theme.effects.boxShadow24), {}, {
      borderRadius: 16,
      display: 'flex',
      flexDirection: 'column'
    }),
    header: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      paddingBottom: 16
    },
    title: {
      color: theme.colors.black
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: 16
    },
    footerLeft: {},
    footerRight: {
      display: 'flex',
      gap: '20px'
    },
    footerComponent: {
      display: 'flex',
      flexGrow: 1
    },
    content: _objectSpread({
      position: 'relative',
      overflow: 'auto'
    }, theme.utils.scrollbar),
    preComponent: {
      marginBottom: '8px'
    },
    postComponent: {
      marginTop: '8px'
    },
    closeIcon: {
      flexShrink: 0
    },
    confirmButton: {},
    cancelButton: {},
    deleteButton: {
      color: theme.colors.red500,
      '&:hover': {
        color: theme.colors.red600
      }
    }
  };
});